import { combineReducers } from 'redux';
import { RESET_STORE } from '../constants/initialization';
import { GAMES_RESOURCE_NAME } from '../constants/search';
import domain from './domain';
import app from './app';
import ui from './ui';

const applicationReducer = combineReducers({
  domain,
  app,
  ui,
});

/**
 * Reset "redux-search" library state.
 * State's structure is created during initialization store phase,
 * so we should persist it with initial values during state reset action.
 */
const savedResetStoreAfterOmit = {
  app: {
    search: {
      [GAMES_RESOURCE_NAME]: {
        text: '',
        isSearching: false,
        result: [],
      },
    },
  },
};

const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    state = savedResetStoreAfterOmit;
  }

  return applicationReducer(state, action);
};

export default rootReducer;
